export default "__VITE_ASSET__5f962e20__"